// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseConditionStatus } from './ResponseConditionStatus';
import {
  ResponseConditionStatusFromJSON,
  ResponseConditionStatusFromJSONTyped,
  ResponseConditionStatusToJSON,
  ResponseConditionStatusToJSONTyped,
} from './ResponseConditionStatus';
import type { ResponseRolloutReasonType } from './ResponseRolloutReasonType';
import {
  ResponseRolloutReasonTypeFromJSON,
  ResponseRolloutReasonTypeFromJSONTyped,
  ResponseRolloutReasonTypeToJSON,
  ResponseRolloutReasonTypeToJSONTyped,
} from './ResponseRolloutReasonType';
import type { ResponseRolloutConditionType } from './ResponseRolloutConditionType';
import {
  ResponseRolloutConditionTypeFromJSON,
  ResponseRolloutConditionTypeFromJSONTyped,
  ResponseRolloutConditionTypeToJSON,
  ResponseRolloutConditionTypeToJSONTyped,
} from './ResponseRolloutConditionType';

/**
 *
 * @export
 * @interface ResponseConditionCount
 */
export interface ResponseConditionCount {
  /**
   *
   * @type {number}
   * @memberof ResponseConditionCount
   */
  clusterRolloutCount?: number;
  /**
   *
   * @type {ResponseRolloutReasonType}
   * @memberof ResponseConditionCount
   */
  reason?: ResponseRolloutReasonType;
  /**
   *
   * @type {ResponseConditionStatus}
   * @memberof ResponseConditionCount
   */
  status?: ResponseConditionStatus;
  /**
   *
   * @type {ResponseRolloutConditionType}
   * @memberof ResponseConditionCount
   */
  type?: ResponseRolloutConditionType;
}

/**
 * Check if a given object implements the ResponseConditionCount interface.
 */
export function instanceOfResponseConditionCount(
  value: object,
): value is ResponseConditionCount {
  return true;
}

export function ResponseConditionCountFromJSON(
  json: any,
): ResponseConditionCount {
  return ResponseConditionCountFromJSONTyped(json, false);
}

export function ResponseConditionCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseConditionCount {
  if (json == null) {
    return json;
  }
  return {
    clusterRolloutCount:
      json['clusterRolloutCount'] == null
        ? undefined
        : json['clusterRolloutCount'],
    reason:
      json['reason'] == null
        ? undefined
        : ResponseRolloutReasonTypeFromJSON(json['reason']),
    status:
      json['status'] == null
        ? undefined
        : ResponseConditionStatusFromJSON(json['status']),
    type:
      json['type'] == null
        ? undefined
        : ResponseRolloutConditionTypeFromJSON(json['type']),
  };
}

export function ResponseConditionCountToJSON(
  json: any,
): ResponseConditionCount {
  return ResponseConditionCountToJSONTyped(json, false);
}

export function ResponseConditionCountToJSONTyped(
  value?: ResponseConditionCount | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusterRolloutCount: value['clusterRolloutCount'],
    reason: ResponseRolloutReasonTypeToJSON(value['reason']),
    status: ResponseConditionStatusToJSON(value['status']),
    type: ResponseRolloutConditionTypeToJSON(value['type']),
  };
}
